import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import {getAxiosResponse, putOrPostAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { dateConvertToTimeStamp, isValidHttpUrl } from "../../services/Util";
import TreeView from "../../pages/TreeView";
import Constants from "../../Constants";
import { updateTreeValue, updateTab, updateTreeData, addChildrenToTreeData ,setSelectedTreeData} from "../../redux/reducers/TreeSlice";
import { updateCredentialsSet, updateProjectContentType } from "../../redux/reducers/ProjectInfoSlice"
import { updateAssetType } from "../../redux/reducers/CreateProjectAssetTypeSlice";
import { updateProjectRules, resetDynamicAssets } from "../../redux/reducers/DynamicAssetSlice";
import { transformBlankToNull } from '../../services/Util';
import MarketoRestCredential from "../../pages/settings/integrationSettings/MarketoRestCredential";
import jQuery from "jquery";
import { RotatingLines } from "react-loader-spinner";
import SuccessMessage from "../../components/SuccessMessage";
import {isMarketingProgram} from '../../services/IntegrationUtil'
import { useTranslation } from "react-i18next";
import { handleError } from "../../services/authApiRoutes/APImethods";
import { logError } from "../../services/authApiRoutes/APImethods";

export default function MarketoRestIntegration(props) {
  const { t } = useTranslation();
  const translate = t;

  const dispatch = useDispatch();
  const TreeViewMemo = React.memo(TreeView);
  const MarketoRestCredentialMemo = React.memo(MarketoRestCredential);

  const projectData = useSelector((reduxStore) => reduxStore.project_info).value;
  const treeValueRedux = useSelector((redux) => redux.tree_structure).treeValue;
  const custBootstrapDataRedux = useSelector(store => store.customer_bootstrap_data).value;
  const assetTypeRedux = useSelector(redux => redux.asset_type_for_project_creation).value;

  const designStudioFolderId = custBootstrapDataRedux?.preferences && custBootstrapDataRedux.preferences[Constants.MARKETO_DESIGN_STUDIO_FOLDER_ID];
  const marketingActivityFolderId = custBootstrapDataRedux?.preferences && custBootstrapDataRedux.preferences[Constants.MARKETO_MARKETING_ACTIVITY_FOLDER_ID];
	const [projectAssetType,setProjectAssetType]= useState("") ;
  const [credentialData, setCredentialData] = useState({});
  const [designStudioAssetsData, setDesignStudioAssetsData] = useState([]);
  const [marketingActivityAssetsData, setMarketingActivityAssetsData] = useState([]);
  const [showTree, setShowTree] = useState(false);
  const [childData, setChildData] = useState();
  const [tab, setTab] = useState({});
  const [showCredential, setShowCredential] = useState(false);
  const [authCodeMode, setAuthCodeMode] = useState(false);
  const [serverErrorMessage, setServerErrorMessage] = useState([]);
  const [isValidating, setValidating] = useState(false);
  const [successMessage, setSuccessMessage] = useState();
  const [message, setMessage] = useState(Constants.BLANK);
  const selectedDepartment=props.department?.id;

  const deliveryTypeOptions = [
    { value: Constants.STATIC, label: "New Asset" },
    { value: Constants.DYNAMIC, label: "Dynamic Content" },
    { value: Constants.PROGRAM, label: "New Program" }
  ];

  const projectRequestDeliveryTypeOptions = [
    { value: Constants.STATIC, label: "New Asset" },
    { value: Constants.PROGRAM, label: "New Program" }
  ];
  const [marketoRestDeliveryTypeOptions, setMarketoRestDeliveryTypeOptions] = useState(deliveryTypeOptions)

  const selectedTreeData = useSelector(reduxStore => reduxStore.tree_structure).selectedTreeData
  const dispatchDataToTreeSliceRedux = (type, value) => {		
		dispatch(updateTreeValue({
		  type: type,
		  value: value
		}));
	}

  const showCredentialModel = () => {
    setShowCredential(true);
    setShowTree(false);
    document.body.classList.add("modal-open");
  };

  const hideCredentialModel = () => {
    setShowCredential(false);
    setValidating(false);
    document.body.classList.remove("modal-open");
    jQuery(".integration-check-input").prop("checked", false);
  };

  useEffect(() => {
    setShowTree(false);
        if(custBootstrapDataRedux?.roleSet?.customerProjectRequester){
           dispatchDataToTreeSliceRedux("selectedTreeNode", {});

        }
    //getCredential(Constants.MARKETOREST);
    if(selectedTreeData && selectedTreeData.length===0){
        getExistingSelection(Constants.MARKETOREST)
    }
    if (props.isProjectRequest) {
      setMarketoRestDeliveryTypeOptions(projectRequestDeliveryTypeOptions)
    }
  }, []);

   useEffect(()=>{
    if(selectedTreeData && selectedTreeData.length===0){
      getExistingSelection(Constants.MARKETOREST)
    }
   },[projectAssetType]) 

  const getExistingSelection = (service) => {
    const dateTimestamp = dateConvertToTimeStamp();
    if (props.projectRequestId || projectData?.id) {
      let urlString = APIUrls.CUSTOMER_PROJECT_ASSET_CONFIGURATION(projectData?.id);
      if (props.isProjectRequest && props.projectRequestId) {
        urlString = APIUrls.CUSTOMER_PROJECT_REQUEST_ASSET_CONFIGURATION(props.projectRequestId)
      }
      getAxiosResponse(urlString + `?type=${service}&_=${dateTimestamp}`
      ).then((res) => {
        if (res.data.code === 200) {
          let data = []
          if (res.data?.data?.body && res.data?.data?.body?.length > 0) {
            res.data?.data?.body?.forEach(asset => {
              if ((asset?.language === null) || (asset?.language !== projectData?.sourceLanguage) || projectAssetType=== Constants.DYNAMIC) {
                data?.push(asset);
              }
            })
            const result = Object.values(data.reduce((acc, curr, index) => {
              if (!acc[curr.externalId]) {
                acc[curr.externalId] = { ...curr, assetName:curr?.name,language: [curr.language] };
              } else {
                if (!acc[curr.externalId].language.includes(curr.language)) {
                  acc[curr.externalId].language.push(curr.language);
                }
              }
              return acc;
            }, {}));
            dispatch(setSelectedTreeData(result))
          }
        }
      }).catch((err) => {
        handleError(err);
      });
    }
  };


  const tabs = [
    {
      label: "Marketing Activities",
      name: "marketingActivity",
      isActive: true,
    },
    {
      label: "Design Studio",
      name: "designStudio",
    },
  ]

  const programTabs = [
    {
      label: "Marketing Activities",
      name: "marketingActivity",
      isActive: true,
    }
  ]

  const setDeliveryTypesSelected = (assetType) => {
    marketoRestDeliveryTypeOptions.map(type => {
      if (assetType === type.value) {
        type.isSelected = true;
      } else {
        type.isSelected = false;
      }
    })
    setMarketoRestDeliveryTypeOptions(marketoRestDeliveryTypeOptions);
  }

  const loadMarketoTree = (assetType) => {
    setMessage("Please wait, your assets are being loaded...")
    dispatchDataToTreeSliceRedux("displayName", "name");
    dispatchDataToTreeSliceRedux("contentType", "MarketoRest");
    dispatchDataToTreeSliceRedux("isTreeLoading", true);
    if(custBootstrapDataRedux?.roleSet?.customerProjectRequester){
     dispatch(setSelectedTreeData([]));
    }
    dispatch(updateTab(tabs))
    setTab(tabs[0]);    
    setDeliveryTypesSelected(assetType);
    // clearSelectedTreeOnDeliveryTypeChange(assetType);
    getMarketoRestTree(designStudioFolderId, 'Folder', designStudioFolderId, false, 'Zone', setDesignStudioAssetsData, true);
    getMarketoRestTree(marketingActivityFolderId, 'Folder', marketingActivityFolderId, false, 'Zone', setMarketingActivityAssetsData);
    if (assetType === Constants.DYNAMIC) {
      setProjectAssetType(Constants.DYNAMIC)
      dispatch(updateAssetType(Constants.DYNAMIC))
      getProjectRules();
    } else if(assetType === Constants.PROGRAM) {
      dispatch(updateTab(programTabs))
      dispatch(updateAssetType(Constants.PROGRAM))
    } else {
      dispatch(resetDynamicAssets())
      dispatch(updateAssetType(Constants.STATIC))
    }
  };

  function clearSelectedTreeOnDeliveryTypeChange(assetType) {
    if (assetType !== assetTypeRedux) {
      dispatch(setSelectedTreeData([]));
    }
  }

  const onTabChange = (tab) => {
    setTab(tab);
    switch(tab.name) {
      case Constants.MARKETING_ACTIVITY :
        return dispatch(updateTreeData(marketingActivityAssetsData));
      case Constants.DESIGN_STUDIO :
        return dispatch(updateTreeData(designStudioAssetsData));
      default :
        return;
    }
  };

  useEffect(() => {
    let node = treeValueRedux.selectedTreeNode;
    let assetType = isMarketingProgram(node) ? 'Program' : 'Folder';
    switch(tab.name) {
      case Constants.MARKETING_ACTIVITY :
        return getMarketoRestTree(node.id, assetType, marketingActivityFolderId, node.programOrChild, node.folderType, setChildData);
      case Constants.DESIGN_STUDIO :
        return getMarketoRestTree(node.id, assetType, designStudioFolderId, node.programOrChild, node.folderType, setChildData);
      default :
        return;
    } 
  }, [treeValueRedux.selectedTreeNode])

  useEffect(() => {
    if (marketingActivityAssetsData.length > 0) {
      dispatch(updateTreeData(marketingActivityAssetsData)) 
    }  
  }, [marketingActivityAssetsData]);

  useEffect(() => {
    if (Array.isArray(childData) && childData.length > 0) {
      let cloneNode = JSON.parse(JSON.stringify(treeValueRedux.selectedTreeNode))
      cloneNode.children = childData;
      dispatch(addChildrenToTreeData(cloneNode))
    }
  }, [childData])

  const submitCredential = (isForSystemUser) => {
    if(!validateCredential()) {
      return;
    }
    setSuccessMessage("Validating credentials...")
    setValidating(true);
    var isPost = true;
    var urlString;
    let localCredentialData = credentialData;    
    let dataToSave;
    if (authCodeMode) {	
      dataToSave = JSON.parse(JSON.stringify(localCredentialData));
      urlString = APIUrls.MARKETO_DEVICE_AUTHORIZATION;	
      dataToSave.credentials.DEVICE_AUTH_CODE = jQuery.trim(jQuery("#marketo-rest-authcode-input").val());
    } else {
        dataToSave = {credentials:{
        CLIENT_ID : jQuery.trim(jQuery("#marketo-client-id-input").val()),
        CLIENT_SECRET : jQuery.trim(jQuery("#marketo-client-secret-input").val()),
        IDENTITY_URL : jQuery.trim(jQuery("#marketo-identity-url-input").val()),
        ENDPOINT_URL : jQuery.trim(jQuery("#marketo-endpoint-url-input").val())  	  
        }, credentialsType: "MARKETOREST"};
        urlString = APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(Constants.MARKETOREST);
        dataToSave.credentials.USERNAME = jQuery.trim(jQuery("#marketo-rest-username-input").val())    	  		
        dataToSave.credentialCharArray = jQuery.trim(jQuery("#marketo-rest-password-input").val()).split('')	  			   
    }
    if(localCredentialData?.id){
      isPost = false;
      dataToSave.id = localCredentialData?.id;
    }

    putOrPostAxiosResponse(urlString, dataToSave, isPost
      ).then((res) => {
        setSuccessMessage(Constants.BLANK)
        setValidating(false);
        if (res.data?.handledMessage?.indexOf("Device Verification") > 0) {
          setAuthCodeMode(true);
          getCredential(Constants.MARKETOREST);
        } else if (res.data?.handledMessage || res.data?.data?.handledMessage){
          setAuthCodeMode(false);
          setServerErrorMessage([res.data.handledMessage])
        } else {
          setServerErrorMessage([])
          setSuccessMessage("Credential successfully updated!")
          hideCredentialModel();
        }
      }).catch((err) => {
        setValidating(false);
        setSuccessMessage(Constants.BLANK)
        const errorMessage = "err - ";
            logError(errorMessage, err); 
      })
  }

  const validateCredential = () => {
    setServerErrorMessage([]);
    var errorMsgs = [];

    if (authCodeMode) {
      if (jQuery.trim(jQuery("#marketo-rest-authcode-input").val()) == "") {
        errorMsgs.push("Please enter auth code for Marketo Rest.")
      }
    } else {
      if (jQuery.trim(jQuery("#marketo-client-id-input").val()) == ""){
        errorMsgs.push("Please enter client id for Marketo Rest.")
      } 
      if (jQuery.trim(jQuery("#marketo-client-secret-input").val()) == ""){
        errorMsgs.push("Please enter client secret for Marketo Rest.");
      }  
      if (!isValidHttpUrl(jQuery.trim(jQuery("#marketo-identity-url-input").val()))){
        errorMsgs.push("Please enter valid identity url for Marketo Rest.");
      } 
      if (!isValidHttpUrl(jQuery.trim(jQuery("#marketo-endpoint-url-input").val()))){
        errorMsgs.push("Please enter valid endpoint url for Marketo Rest.");
      }

      let username = jQuery.trim(jQuery("#marketo-rest-username-input").val());
      let password = jQuery.trim(jQuery("#marketo-rest-password-input").val())
      if (username == "" && password != ""){
        errorMsgs.push("Please enter Username for Marketo Rest.");
      } 
      if (password == "" && username != ""){
        errorMsgs.push("Please enter Password for Marketo Rest.");
      }
    }
    if (errorMsgs.length > 0) {
      setServerErrorMessage(errorMsgs);
      return false;
    } else {
      setServerErrorMessage([]);
      return true;
    }
  }

  const getCredential = (service) => {
    setValidating(true)
    setMessage("Checking credentials...")
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(service) + `?_=${dateTimestamp}`
    ).then (res => {
      setValidating(false)
      setMessage(Constants.BLANK)
      if (res.data.code === 200) {
        var credentialsSet = transformBlankToNull(res.data.data.body)
        if (credentialsSet !== null && credentialsSet.credentials !== null) {
          setCredentialData(credentialsSet)
          dispatch(updateCredentialsSet(credentialsSet))
          dispatch(updateProjectContentType(Constants.MARKETOREST));
        } else {
          showCredentialModel();
        }
      }
    }).catch(err => {
      setMessage(Constants.BLANK)
      handleError(err);
      setValidating(false)
    });
  };

  const getMarketoRestTree = (nodeId, folderType, treeId, programOrChild, nodeType, setValue, isFirstCall) => {
    setValidating(true);
    const dateTimestamp = dateConvertToTimeStamp();
    let urlString = APIUrls.MARKETO_REST_ASSETS(projectData?.id)
    if (props.isProjectRequest) {
      urlString = APIUrls.MARKETO_REST_ASSETS_PROJECTLESS
    }
    const queryParams = [
      `nodeId=${nodeId}`,
      `folderType=${folderType}`,
      `treeId=${treeId}`,
      `programOrChild=${programOrChild}`,
      `nodeType=${nodeType}`
    ];
    if (selectedDepartment !== null && selectedDepartment!==undefined) {
      queryParams.push(`departmentId=${selectedDepartment}`);
    }
    queryParams.push(`_=${dateTimestamp}`);
    getAxiosResponse(
      urlString + `?${queryParams.join('&')}`
    ).then((res) => {
      setValidating(false);
      setMessage(Constants.BLANK)
      dispatchDataToTreeSliceRedux("isTreeLoading", false);
        if (res.data?.handledMessage === "no credentials!" || res.data?.handledMessage !== undefined) {
          if (isFirstCall) {
            showCredentialModel();
          }
        } else if (res.data.code === 200) {
          let result = transformBlankToNull(res.data.data.result);
          result.children = [];
          setValue(result);
          setShowTree(true);
        }
    }).catch((err) => {
      setMessage(Constants.BLANK)
        handleError(err);
        dispatchDataToTreeSliceRedux("isTreeLoading", false);
        setValidating(false);
    });
  };

	 const getProjectRules = () => {
	 	const dateTimestamp = dateConvertToTimeStamp();
	 	getAxiosResponse(
	 	  APIUrls.MARKETO_REST_ASSET_PROJECT_RULE(projectData?.id) + `?_=${dateTimestamp}`
	 	).then((res) => {
	 	  if (res.data.code === 200) {
        const projectRules = transformBlankToNull(res.data.data);
	 		  dispatch(updateProjectRules(projectRules));
	 	  }
	 	}).catch((err) => {
	 	  handleError(err);
	 	});
	}
  
  return (
    <>
      <div className={isValidating ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div> 
      {!showTree ? (
        <div className="create-project-section">
          <div className="step-1-section">
            <div className="project-heading">
              <h3>Source materials for this project? </h3>
              <label>Click on an option below to select <sup>*</sup></label>
            </div>
            <div className="marketo-default-wrap integration-asset-view">
              <div
                className="marketo-default-list flex-center"
                role="button"
                aria-label="New Asset"
                tabIndex="0"
              >
                <div className="left flex-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="30"
                    viewBox="0 0 32 30"
                    fill="none"
                  >
                    <path
                      d="M31 13V5H14L10 1H1V27H13"
                      stroke="#2A4274"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M14 5H8"
                      stroke="#2A4274"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M10 1H19L23 5"
                      stroke="#2A4274"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M23 29C27.4183 29 31 25.4183 31 21C31 16.5817 27.4183 13 23 13C18.5817 13 15 16.5817 15 21C15 25.4183 18.5817 29 23 29Z"
                      stroke="#2A4274"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M23 17V25"
                      stroke="#2A4274"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M27 21H19"
                      stroke="#2A4274"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <div className="right" onClick={() => loadMarketoTree(Constants.STATIC)}>
                  <strong>New Asset</strong>
                  <p>
{translate("other_integrations_project_creation.marketo_asset_copy")}                  </p>
                </div>
              </div>
              <div
                className="marketo-default-list flex-center"
                role="button"
                aria-label="New Program"
                tabIndex="0"
              >
                <div className="left flex-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                  >
                    <path
                      d="M29.0625 4.6875H13.125L9.375 0.9375H0.9375V25.3125H8.4375"
                      stroke="#2A4274"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M13.125 4.6875H7.5"
                      stroke="#2A4274"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M9.375 0.9375H17.8125L21.5625 4.6875"
                      stroke="#2A4274"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M17.8125 8.4375H29.0625V29.0625H12.1875V14.0625L17.8125 8.4375Z"
                      stroke="#2A4274"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M17.8125 8.4375V14.0625H12.1875"
                      stroke="#2A4274"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M15.9375 19.6875H25.3125"
                      stroke="#2A4274"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M15.9375 23.4375H25.3125"
                      stroke="#2A4274"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <div className="right" onClick={() => loadMarketoTree("PROGRAM")}>
                  <strong>New Program</strong>
                  <p>
{translate("other_integrations_project_creation.marketo_asset_copy")}                  </p>
                </div>
              </div>
              {!props.isProjectRequest &&
              <div
                className="marketo-default-list flex-center"
                role="button"
                aria-label="Dynamic Content"
                tabIndex="0"
              >
                <div className="left flex-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="30"
                    viewBox="0 0 32 30"
                    fill="none"
                  >
                    <path
                      d="M30 6H28V4C28 3.46957 27.7893 2.96086 27.4142 2.58579C27.0391 2.21071 26.5304 2 26 2H16V1C16 0.734784 15.8946 0.48043 15.7071 0.292893C15.5196 0.105357 15.2652 0 15 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1L0 28C0 28.5304 0.210714 29.0391 0.585786 29.4142C0.960859 29.7893 1.46957 30 2 30H30C30.5304 30 31.0391 29.7893 31.4142 29.4142C31.7893 29.0391 32 28.5304 32 28V8C32 7.46957 31.7893 6.96086 31.4142 6.58579C31.0391 6.21071 30.5304 6 30 6ZM26 4V6H16V4H26ZM30 28H2V2H14V6H5V8H30V28Z"
                      fill="#2A4274"
                    ></path>
                    <path
                      d="M11.9991 18C11.8675 17.9992 11.737 18.0245 11.6152 18.0742C11.4933 18.124 11.3825 18.1973 11.2891 18.29L7.28906 22.29L8.69906 23.7L12.4091 20H17.9991C18.1307 20.0008 18.2611 19.9755 18.383 19.9258C18.5048 19.876 18.6156 19.8027 18.7091 19.71L22.9991 15.41V18H24.9991V13C24.9991 12.7348 24.8937 12.4804 24.7062 12.2929C24.5186 12.1054 24.2643 12 23.9991 12H18.9991V14H21.5891L17.5891 18H11.9991Z"
                      fill="#2A4274"
                    ></path>
                  </svg>
                </div>
                <div className="right" onClick={() => loadMarketoTree(Constants.DYNAMIC)}>
                  <strong>
                    Dynamic Content
                  </strong>
                  <p>
                  {translate("other_integrations_project_creation.marketo_asset_copy")}                    </p>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      ) : (
        <div>
            <TreeViewMemo 
              onTabChange={onTabChange} 
              deliveryTypes={marketoRestDeliveryTypeOptions} 
              changeDeliveryType={loadMarketoTree}
            />
        </div>
      )}
      {showCredential && 
        <div className="lightbox-panel sm-lg-lightbox-panel">
        <div className="inner-lightbox-panel pb-0">
        <div className="modal-header flex padd-lr">
          <strong>MarketoRest Integration</strong>
          <button className="close" aria-label="close popup" onClick={() => hideCredentialModel()}>
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path><path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path></svg>
          </button>
        </div>
        <div className="lightbox-content padd-22">
           <div className="flex">
            <div className="leftBlock">
               <p>Please log in to your Marketo account to access your marketing assets through OPAL-Marketing.</p>
               <p>Once you have logged in, you will be able to see all of your Marketo assets and automate their translation.</p>
               <p><a href="#">Learn More about Marketo Integration</a></p>
              {authCodeMode &&
                <><span className="error">
                  Marketo requires that you register this device before continuing. 
                  Please check your email for a device authentication request from Marketo within the next few minutes.
                </span><br /><br />              
                On the email from Marketo, you will find an Authorization Code. 
                Please type or copy and paste the code to the box on this page and click the Save button.<br /><br /> 
              </>
              }
            </div>
            <div className="rightBlock">
              <div className="flex wrap-dropdown flex-column mb-0">
                <MarketoRestCredentialMemo 
                  authCodeMode = {authCodeMode}
                  credentialData = {credentialData} 
                  errorMessages = {serverErrorMessage}
                  isValidating = {isValidating}
                  successMessage = {successMessage}
                  closePopup = {hideCredentialModel}
                />
              </div>
            </div>
            
           </div>
        </div>	
        <div className="modal-footer modal-footer-border flex px-22">
              <button className="btn btn-bold" onClick={() => hideCredentialModel()}>Cancel</button>
              <button id="save-credential" className="btn btn-bold active" onClick={() => submitCredential(true)}>Save</button>
          </div>
        </div>		
      </div>
      }
      {(message!==undefined && message !== Constants.BLANK)?<SuccessMessage message={message}/>:Constants.BLANK}
    </>
  );
}
